import { useEffect, useState } from "react";
import { X, Wallet } from "lucide-react";
import { fmtInr } from "@/lib/api";

export const RoseGiftPopup = ({ gifts, coins, onSend, onClose, onRecharge }) => (
  <div data-testid="rose-gift-popup" className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center" onClick={onClose}>
    <div className="absolute inset-0 bg-black/50" />
    <div className="relative w-full sm:max-w-sm glass rounded-t-3xl sm:rounded-3xl p-4 pb-6 text-white fade-up" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between mb-3">
        <div><p className="label-caps">ഗിഫ്റ്റ്</p><h3 className="font-display text-lg font-bold">🎁 ഗിഫ്റ്റ് അയക്കുക</h3></div>
        <div className="flex items-center gap-2">
          <span data-testid="rose-popup-coins" className="font-num text-xs rounded-full border border-amber-300/60 px-2.5 h-7 inline-flex items-center bg-amber-50/10 text-amber-200 font-bold">{fmtInr(coins)}</span>
          <button type="button" data-testid="rose-popup-close" onClick={onClose} className="w-8 h-8 rounded-full glass inline-flex items-center justify-center"><X size={14} /></button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {gifts.map((g) => {
          const can = coins >= g.cost;
          return (
            <button key={g.id} type="button" data-testid={`rose-gift-${g.id}`} disabled={!can} onClick={() => onSend(g.id)} className="rounded-2xl p-3 text-center bg-white/10 border border-white/15 hover:bg-white/20 hover:scale-105 active:scale-95 transition disabled:opacity-40 disabled:hover:scale-100">
              <div className="text-3xl leading-none tracking-tighter">{g.emoji}</div>
              <p className="text-[11px] font-semibold mt-2 truncate">{g.name}</p>
              <p className="font-num text-[11px] text-amber-200 font-bold">₹{g.cost / 6}</p>
            </button>
          );
        })}
      </div>
      {onRecharge && gifts.some((g) => coins < g.cost) && <button type="button" data-testid="gift-recharge-button" onClick={onRecharge} className="recharge-btn w-full h-10 rounded-full text-xs font-bold inline-flex items-center justify-center gap-2 mt-3"><Wallet size={13} /> റീചാർജ് ചെയ്യുക</button>}
      <p className="text-[10px] text-white/60 mt-3 text-center">ഗിഫ്റ്റ് തുക ഉടൻ കുറയും · സ്റ്റാഫിന് 50% തത്സമയം ക്രെഡിറ്റ് · കോൾ തടസ്സമില്ലാതെ തുടരും</p>
    </div>
  </div>
);

export const RoseBurst = ({ event }) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!event) return undefined;
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2600);
    return () => clearTimeout(t);
  }, [event]);
  if (!event || !visible) return null;
  const roses = (event.gift?.emoji || "🌹").length / 2 || 1;
  const n = Math.min(12, 4 + roses * 3);
  return (
    <div key={event.t} className="absolute inset-0 pointer-events-none z-20 overflow-hidden">
      {Array.from({ length: n }).map((_, i) => (
        <span key={i} className="rose-float absolute bottom-24 text-3xl" style={{ left: `${10 + ((i * 37) % 80)}%`, animationDelay: `${i * 0.12}s`, animationDuration: `${1.6 + (i % 3) * 0.3}s` }}>🌹</span>
      ))}
      <div className="absolute inset-0 flex items-center justify-center"><span className="gift-pop text-7xl">{event.gift?.emoji}</span></div>
    </div>
  );
};
